import { render, staticRenderFns } from "./sideNavigation.vue?vue&type=template&id=856421d6&scoped=true&"
import script from "./sideNavigation.vue?vue&type=script&lang=js&"
export * from "./sideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./sideNavigation.vue?vue&type=style&index=0&id=856421d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856421d6",
  null
  
)

export default component.exports